module.exports = __webpack_public_path__ + "img/35.c40fafb8.svg";